import { isNonNullable } from "../../utils";
export var exposeGetters = function exposeGetters(theme) {
  var descriptors = Object.getOwnPropertyDescriptors(theme);
  Object.keys(descriptors).forEach(function (key) {
    var descriptor = descriptors[key];

    if (typeof descriptor.get === 'function' && descriptor.configurable) {
      descriptor.enumerable = true;
      Object.defineProperty(theme, key, descriptor);
    }
  });
  return theme;
};
export var REACT_UI_THEME_MARKERS = {
  darkTheme: {
    key: '__IS_REACT_UI_DARK_THEME__',
    value: true
  },
  theme2022: {
    key: '__IS_REACT_UI_THEME_2022__',
    value: true
  }
}; // backward compatible

export var REACT_UI_DARK_THEME_KEY = REACT_UI_THEME_MARKERS.darkTheme.key;
export var isDarkTheme = function isDarkTheme(theme) {
  // @ts-expect-error: internal value.
  return theme[REACT_UI_THEME_MARKERS.darkTheme.key] === REACT_UI_THEME_MARKERS.darkTheme.value;
};
export var markAsDarkTheme = function markAsDarkTheme(theme) {
  var _Object$create;

  return Object.create(theme, (_Object$create = {}, _Object$create[REACT_UI_THEME_MARKERS.darkTheme.key] = {
    value: REACT_UI_THEME_MARKERS.darkTheme.value,
    writable: false,
    enumerable: false,
    configurable: false
  }, _Object$create));
};
export var markAsTheme2022 = function markAsTheme2022(theme) {
  var _Object$create2;

  return Object.create(theme, (_Object$create2 = {}, _Object$create2[REACT_UI_THEME_MARKERS.theme2022.key] = {
    value: REACT_UI_THEME_MARKERS.theme2022.value,
    writable: false,
    enumerable: false,
    configurable: false
  }, _Object$create2));
};
export var isTheme2022 = function isTheme2022(theme) {
  // @ts-expect-error: internal value.
  return theme[REACT_UI_THEME_MARKERS.theme2022.key] === REACT_UI_THEME_MARKERS.theme2022.value;
};
export function findPropertyDescriptor(theme, propName) {
  // TODO: Rewrite for loop.
  // TODO: Enable `no-param-reassign` rule.
  // eslint-disable-next-line no-param-reassign
  for (; isNonNullable(theme); theme = Object.getPrototypeOf(theme)) {
    if (Object.prototype.hasOwnProperty.call(theme, propName)) {
      return Object.getOwnPropertyDescriptor(theme, propName) || {};
    }
  }

  return {};
}
export function applyMarkers(theme, markers) {
  var markedTheme = theme;
  markers.forEach(function (marker) {
    markedTheme = marker(theme);
  });
  return markedTheme;
}